import React, { useState, useEffect, useRef } from 'react'
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { ADD_CHALLAN_FAIL } from "../../RTK/Slices/ChallanSlice";
import {
    add_budget_surrender,
    get_schemes,
    fetchDepartmentSurrenderBudgets
} from '../../helper/Api';
import { toast } from 'react-toastify';
import CustomBreadcrumbs from '../Tools/Breadcumbs';
import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem,
    TextField,
    Checkbox,
} from "@mui/material";
import Spinner from '../Tools/spinner';

export default function AddBudgetSurrenderComponent() {
    const dispatch = useDispatch();
        const { authData, financialYears } = useSelector((state) => state.authData);
        const [loading, setLoading] = useState(false)
        const { id } = useParams();
        const [schemes, set_schemes] = useState([]);
        const fy_list = financialYears.payload.fy_list;
        const [departmentRecords, setDepartmentRecords] = useState([]);
        const totalAmount = useRef(0);
        const totalFromAmount = useRef(0);
        const navigate = useNavigate();
        const [selectedBudget, setSelectedBudget] = useState([]);
        const [formData, setFormData] = useState({
            id: '',
            department_level: authData.user.department_details.is_multi === "1" ? "" : 'T1',
            budget_surrender_order_no: '',
            budget_surrender_order_date: '',
            budget_surrender_order_value: '',
            attachment: [],
            department_Id: "",
            department_name: "",
            financial_id: '',
            financial_year: '',
            activity: [],
            subhead_id: '',
            department_count: selectedBudget.length,
            created_by: authData && authData.status ? authData.user.id : null
        });
        const [showConfirm, setShowConfirm] = useState(false);
        const [fromSchemeDetails, setFromSchemeDetails] = useState({
            scheme_id: '',
            scheme_name: '',
            department_name: '',
            grant_code: '',
            scheme_type: '',
            financial_id: '',
            financial_year: '',
            monitoring_level: '',
            is_activity_active: '',
        });
        // handle formal formdata
        const handleChallanFormData = (e) => {
            const name = e.target.name;
            const value = e.target.value;
            setFormData({
                ...formData,
                [name]: value
            });
            
        }
        // handle from scheme details
        const handleSchemeChange = async (event) => {
            const selectedSchemeId = event.target.value;
            if (selectedSchemeId && fromSchemeDetails.scheme_id) {
                setShowConfirm(true);
                return
            }
            const selectedScheme = schemes.find(scheme => scheme.id === selectedSchemeId);
            setFromSchemeDetails({
                ...fromSchemeDetails,
                scheme_id: selectedScheme.id,
                scheme_name: selectedScheme.name,
                department_name: selectedScheme.department,
                grant_code: selectedScheme.grant_code,
                scheme_type: selectedScheme.type,
                monitoring_level: selectedScheme.monitoring_level,
                is_activity_active: selectedScheme.is_activity_active,
            });
            try {
                setLoading(true);
                let payload = {
                    fy_id: formData.financial_id,
                    scheme_id: event.target.value,
                    department_level: formData.department_level
                }
                let res = await fetchDepartmentSurrenderBudgets(payload);
                if(res.data.status) {
                    setLoading(false);
                    if(Number(authData.user.department_details.id) !== 1) {
                        setDepartmentRecords(res.data.schemes.filter(e => Number(e.parent_department_id) === Number(authData.user.department_details.id)));
                    } else {
                        setDepartmentRecords(res.data.schemes)
                    }
                }

            }catch(error) {
                setLoading(false);
                toast.error("Something went wrong!", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        };
        //change financial year 
        const handleFinancialYearChange = (event) => {
            const selectedYearId = event.target.value;
            const selectedYearName = fy_list.find(e => e.id === selectedYearId);
            setFromSchemeDetails({
                ...fromSchemeDetails,
                financial_id: selectedYearId,
                financial_year: selectedYearName.start_year+"-"+selectedYearName.end_year,
            });
            setFormData({
                ...formData,
                financial_id: selectedYearId,
                financial_year: selectedYearName.start_year+"-"+selectedYearName.end_year,
            });
            fetch_list(formData.department_Id, selectedYearId);
        };
      

        const fetch_list = async (financial_id) => {
            setLoading(true);
            const schemes_list = await get_schemes({ department_id: authData.user.department_id, fy_id: financial_id });
            if (schemes_list.data.status) {
                set_schemes(schemes_list.data.schemes);
                setLoading(false);
            } else {
                set_schemes([]);
            }
            // if (id) {}
    
        }
    
        const handleSubmit = async (e) => {
            if (!id) {
                if (e && typeof e.preventDefault === 'function') {
                    e.preventDefault();
                }
            }
            try {
                if (formData.budget_surrender_order_no &&
                    formData.budget_surrender_order_date && formData.budget_surrender_order_value > 0) {
                    let surrenderPayload = [];
                    selectedBudget.forEach((e) => {
                        if(surrenderPayload.length) {
                            let index = surrenderPayload.findIndex(f => f.subhead_id === e.subhead_id && f.department_id === e.department_id);
                            if(index !== -1) {
                                surrenderPayload[index].budget_surrender_order_value += e.surrender_budget
                                surrenderPayload[index].subheads.push({
                                    subhead_id: e.id,
                                    amount: e.surrender_budget,
                                    activity: e.activity_budget
                                });
                            } else {
                                let obj = {
                                    scheme_id: fromSchemeDetails.scheme_id,
                                    financial_year: formData.financial_id,
                                    budget_surrender_order_no: formData.budget_surrender_order_no,
                                    budget_surrender_order_date: formData.budget_surrender_order_date,
                                    budget_surrender_order_value: e.surrender_budget,
                                    department_id: e.department_id,
                                    parent_department_id: e.parent_department_id,
                                    created_by: formData.created_by,
                                    doc_url: "",
                                    subheads: [{
                                        subhead_id: e.id,
                                        amount: e.surrender_budget,
                                        activity: e.activity_budget
                                    }]
                                }
                                surrenderPayload.push(obj);
                            }
                        } else {
                            let obj = {
                                scheme_id: fromSchemeDetails.scheme_id,
                                financial_year: formData.financial_id,
                                budget_surrender_order_no: formData.budget_surrender_order_no,
                                budget_surrender_order_date: formData.budget_surrender_order_date,
                                budget_surrender_order_value: e.surrender_budget,
                                department_id: e.department_id,
                                parent_department_id: e.parent_department_id,
                                created_by: formData.created_by,
                                doc_url: "",
                                subheads: [{
                                    subhead_id: e.id,
                                    amount: e.surrender_budget,
                                    activity: e.activity_budget
                                }]
                            }
                            surrenderPayload.push(obj);
                        }
                    });
                    const response = await add_budget_surrender({surrenderBudget: surrenderPayload});
                    let addDepositoryResponseData = response.data;
                    if (addDepositoryResponseData.status) {
                        toast.success('Budget Surrender Added Successfully', {
                            position: toast.POSITION.TOP_CENTER
                        });
                        navigate('/budget-surrender');
                    } else {
                        toast.error(addDepositoryResponseData.message, {
                            position: toast.POSITION.TOP_CENTER
                        });
                        dispatch(ADD_CHALLAN_FAIL(addDepositoryResponseData.message));
                    }
                } else {
                    toast.error('Please fill required fields.', {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            } catch (error) {
                dispatch(ADD_CHALLAN_FAIL('error getting while updating challan'));
    
            }
        }
    
        // useEffect(() => {
        //     fetch_list();
        // }, []);
        
        const handleConfirm = (value) => {
            setShowConfirm(value)
        }
        const confirmSubmit = () => {
            setShowConfirm(false)
            setFromSchemeDetails({
                scheme_id: '',
                scheme_name: '',
                department_name: '',
                grant_code: '',
                scheme_type: '',
                financial_id: '',
                financial_year: '',
                monitoring_level: '',
                is_activity_active: '',
            });
            totalFromAmount.current = null;
            totalAmount.current = null;
        }
        const linksArray = [
            {
                href: "/budget-surrender",
                label: "Budget Surrender",
            }
        ];
        const handleDepartmentLevelChange = (e) => {
            setFormData((prev) => ({...prev, department_level: e.target.value}))
        }
        const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

        const handleSelectAllBudgets = (isChecked) => {
            if (isChecked) {
                departmentRecords.forEach(row => {
                    row.budget_details[0].sub_head_list.forEach(subhead => {
                        subhead.surrender_budget = subhead.budget;
                        setSelectedBudget(prev => [...prev, subhead]);
                    });
                });
            }else {
                setSelectedBudget([]);
            }
        }

        const handleBudgetSelection = (key, subheadId, departmentId, activityObj, isChecked) => {
            const row = departmentRecords.find(e => Number(e.id) === Number(departmentId));
            const subheadData = row.budget_details[0].sub_head_list.find(f => Number(f.id) === Number(subheadId));
            subheadData.department_id = departmentId;

            if (isChecked) {
                if (key === 'subhead') {
                    subheadData.surrender_budget = subheadData.budget;
                    setSelectedBudget(prev => [...prev, subheadData]);
                }

                if (key === 'activity') {
                    setSelectedBudget(prev => {
                        const updated = [...prev];
                        const subheadIndex = updated.findIndex(
                        e => Number(e.id) === Number(subheadId) && Number(e.department_id) === Number(departmentId)
                        );

                        if (subheadIndex !== -1) {
                        const subhead = updated[subheadIndex];

                        // Ensure activity_budget exists
                        if (!subhead.activity_budget) subhead.activity_budget = [];

                        // Prevent duplicate
                        const alreadyAdded = subhead.activity_budget.find(
                            f =>
                            Number(f.subhead_activity_id) === Number(activityObj.subhead_activity_id) &&
                            Number(f.subhead_subactivity_id) === Number(activityObj.subhead_subactivity_id)
                        );

                        if (!alreadyAdded) {
                            subhead.activity_budget.push(activityObj);

                        
                            subhead.surrender_budget = subhead.activity_budget.reduce(
                            (sum, obj) => sum + Number(obj.budget || 0), 0
                            );
                        }
                        } else {
                        // Subhead not in selectedBudget, add new with activity + surrender_budget
                        updated.push({
                            ...subheadData,
                            activity_budget: [activityObj],
                            surrender_budget: Number(activityObj.budget || 0)
                        });
                        }

                        return updated;
                    });
                }
            } else {
                if (key === 'subhead') {
                setSelectedBudget(prev =>
                    prev.filter(
                    f => !(Number(f.id) === Number(subheadId) && Number(f.department_id) === Number(departmentId))
                    )
                );
                }

                if (key === 'activity') {
                setSelectedBudget(prev => {
                    return prev.reduce((acc, curr) => {
                    if (Number(curr.id) === Number(subheadId) && Number(curr.department_id) === Number(departmentId)) {
                        const updatedActivities = curr.activity_budget?.filter(
                        f =>
                            !(
                            Number(f.subhead_activity_id) === Number(activityObj.subhead_activity_id) &&
                            Number(f.subhead_subactivity_id) === Number(activityObj.subhead_subactivity_id)
                            )
                        );

                        if (updatedActivities?.length) {
                        acc.push({
                            ...curr,
                            activity_budget: updatedActivities,
                            surrender_budget: updatedActivities.reduce(
                            (sum, obj) => sum + Number(obj.budget || 0), 0
                            )
                        });
                        }
                    } else {
                        acc.push(curr); // no change
                    }
                    return acc;
                    }, []);
                });
                }
            }
            };

    useEffect(() => {
        const totalSurrender = selectedBudget?.reduce((sum, subhead) => {
            return sum + Number(subhead.surrender_budget || 0);
        }, 0);

        setFormData(prev => ({
            ...prev,
            budget_surrender_order_value: totalSurrender
        }));
    }, [selectedBudget]);

        return (
            <>
            {loading && <div > <Spinner/> </div>}
                <div>
                    <div className="p-3">
                        <div className="row">
                            <div className="col-md-6">
                                <h4 style={{ color: "#28326f", margin: 0 }}>Add Budget Surrender</h4>
                                <CustomBreadcrumbs linksArray={linksArray} title="Add Budget Surrender" />
                            </div>
                            <div className="col-md-6">
                                <div
                                className="d-flex gap-2"
                                style={{ width: "auto", float: "right" }}
                                >
                                <button type="submit" className="submit_button" onClick={handleSubmit}>Submit</button> 
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {/* <Form onSubmit={previewHandler}> */}
                            <div className="col-md-12">
                                <div className="card p-3 mt-3">
                                    <div className="row">
                                        {
                                            authData.user.department_details.is_multi === "1" && (
                                                <div className='col-md-12 mb-3'>
                                                    <label htmlFor="inputType">
                                                        Department Tier <span className="text-danger">*</span>
                                                    </label><br/>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="T1"
                                                            name="reimbursement_payment_levels"
                                                            value="T1"
                                                            checked={formData.department_level === 'T1'}
                                                            onChange={handleDepartmentLevelChange}
                                                            className="form-check-input"
                                                        />
                                                        <label className="form-check-label" htmlFor="T1">
                                                            T1
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="T2"
                                                            name="reimbursement_payment_levels"
                                                            value="T2"
                                                            checked={formData.department_level === 'T2'}
                                                            onChange={handleDepartmentLevelChange}
                                                            className="form-check-input"
                                                        />
                                                        <label className="form-check-label" htmlFor="T2">
                                                            T2
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="T3"
                                                            name="reimbursement_payment_levels"
                                                            value="T3"
                                                            checked={formData.department_level === 'T3'}
                                                            onChange={handleDepartmentLevelChange}
                                                            className="form-check-input"
                                                        />
                                                        <label className="form-check-label" htmlFor="T3">
                                                            T3
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="T4"
                                                            name="reimbursement_payment_levels"
                                                            value="T4"
                                                            checked={formData.department_level === 'T4'}
                                                            onChange={handleDepartmentLevelChange}
                                                            className="form-check-input"
                                                        />
                                                        <label className="form-check-label" htmlFor="T4">
                                                            T4
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        
                                        <div className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden mb-3">
                                            <span className="fs-14px white-space-nowrap overflow-x-hidden fw-600 fs-16px" style={{ width: "95%", fontStyle: "normal" }} >Scheme Details</span>
                                        </div>
                                        <div className='col-md-4 mb-3'>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Financial Year *</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={formData.financial_id || ""}
                                                    label="Financial Year *"
                                                    name="financial_year"
                                                    onChange={handleFinancialYearChange}
                                                    disabled={!formData.department_level}
                                                >
                                                    {fy_list.map((fy) => (
                                                        <MenuItem value={fy.id} key={fy.id}>
                                                            {fy.year}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <InputLabel id="scheme-namelabel">Scheme</InputLabel>
                                                <Select
                                                    labelId="scheme-namelabel"
                                                    id="scheme-name-select"
                                                    value={fromSchemeDetails.scheme_id || ""}
                                                    label="Scheme"
                                                    name="scheme_id"
                                                    onChange={handleSchemeChange}
                                                    disabled={!formData.financial_id}
                                                >
                                                {schemes.map((scheme) => (
                                                    <MenuItem value={scheme.id} key={scheme.id}>
                                                    {scheme.code} | {scheme.name}
                                                    </MenuItem>
                                                ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Scheme Name"
                                                variant="outlined"
                                                type="text"
                                                readOnly={true}
                                                value={fromSchemeDetails.scheme_name}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Scheme Department Name"
                                                variant="outlined"
                                                type="text"
                                                readOnly={true}
                                                value={fromSchemeDetails.department_name}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Scheme Grant Code"
                                                variant="outlined"
                                                type="text"
                                                readOnly={true}
                                                value={fromSchemeDetails.grant_code}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Scheme Type"
                                                variant="outlined"
                                                type="text"
                                                readOnly={true}
                                                value={fromSchemeDetails.scheme_type}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Budget Order No."
                                                variant="outlined"
                                                type="text"
                                                name="budget_surrender_order_no"
                                                onChange={handleChallanFormData}
                                                value={formData.budget_surrender_order_no || ""}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Budget Order Date"
                                                variant="outlined"
                                                type="date"
                                                name="budget_surrender_order_date"
                                                onChange={handleChallanFormData}
                                                value={formData.budget_surrender_order_date || ""}
                                                InputLabelProps={{ shrink: true }}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Budget Order Value"
                                                variant="outlined"
                                                type="number"
                                                name="budget_surrender_order_value"
                                                value={formData.budget_surrender_order_value || ""}
                                                readOnly={true}
                                                required
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                id="name"
                                                label="Departmen Count"
                                                variant="outlined"
                                                type="number"
                                                value={formData.department_count || ""}
                                                readOnly={true}
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden mb-3">
                                            <span className="fs-14px white-space-nowrap overflow-x-hidden fw-600 fs-16px" style={{ width: "95%", fontStyle: "normal" }} >Budget Selection</span>
                                        </div>
                                        
                                        <div className='col-md-12'>
                                            <table className="table table-responsive surrender-table">
                                                <thead>
                                                    <tr>
                                                        <th className='budget-surrender-head-row' style={{width: '5%', backgroundColor: '#28326f'}}>
                                                            <Checkbox
                                                                {...label}
                                                                style={{color: '#fff'}}
                                                                onChange={(e) => handleSelectAllBudgets(e.target.checked)}
                                                                checked={
                                                                    departmentRecords.length && departmentRecords.every(department =>
                                                                        department.budget_details[0].sub_head_list.every(subhead =>
                                                                            selectedBudget.some(
                                                                                e =>
                                                                                Number(e.id) === Number(subhead.id) &&
                                                                                Number(e.department_id) === Number(department.id)
                                                                            )
                                                                        )
                                                                    )
                                                                }
                                                                disabled={departmentRecords.length === 0}
                                                            />
                                                        </th>
                                                        <th>Department Name</th>
                                                        <th>Scheme Name</th>
                                                        <th>Subhead Name</th>
                                                        <th>Budget Available</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        departmentRecords.map((departmentRecord, index) => 
                                                            departmentRecord.budget_details[0].sub_head_list.map((subhead, subheadIndex) => (
                                                                <>
                                                                <tr key={subheadIndex} style={{borderTop: '2px solid #000'}}>
                                                                    <td>
                                                                        <Checkbox 
                                                                            {...label}
                                                                            onChange={(e) =>
                                                                            handleBudgetSelection('subhead', subhead.id, departmentRecord.id, {}, e.target.checked)
                                                                            }
                                                                            checked={
                                                                                !!(
                                                                                selectedBudget?.find(
                                                                                e =>
                                                                                    Number(e.id) === Number(subhead.id) &&
                                                                                    Number(e.department_id) === Number(departmentRecord.id)
                                                                                )?.activity_budget?.length === subhead?.activity_budget?.length
                                                                                )
                                                                            }
                                                                        />
</td>
                                                                    <td>{departmentRecord.name}</td>
                                                                    <td>{fromSchemeDetails?.scheme_name}</td>
                                                                    <td>{subhead?.name}</td>
                                                                    <td><strong>{subhead?.budget}</strong></td>
                                                                </tr>
                                                                {
                                                                    subhead.activity_budget.map((activity, activityIndex) => (
                                                                        <>
                                                                            {
                                                                                activityIndex === 0 && <tr>
                                                                            <td style={{backgroundColor: "#dff0ff"}}></td>
                                                                            <td style={{backgroundColor: "#dff0ff"}}></td>
                                                                            <td style={{backgroundColor: "#dff0ff"}}><strong>Activity</strong></td>
                                                                            <td style={{backgroundColor: "#dff0ff"}}><strong>Subactivity</strong></td>
                                                                            <td style={{backgroundColor: "#dff0ff"}}></td>
                                                                        </tr>
                                                                            }
                                                                            <tr>
                                                                                <td>
                                                                                    <Checkbox 
                                                                                        onChange={(e) =>
                                                                                            handleBudgetSelection(
                                                                                            'activity',
                                                                                            subhead.id,
                                                                                            departmentRecord.id,
                                                                                            activity,
                                                                                            e.target.checked
                                                                                            )
                                                                                        }
                                                                                        checked={
                                                                                            !!selectedBudget
                                                                                            ?.find(
                                                                                                e =>
                                                                                                Number(e.id) === Number(subhead.id) &&
                                                                                                Number(e.department_id) === Number(departmentRecord.id)
                                                                                            )
                                                                                            ?.activity_budget?.some(
                                                                                                f =>
                                                                                                Number(f.subhead_activity_id) === Number(activity.subhead_activity_id) &&
                                                                                                Number(f.subhead_subactivity_id) === Number(activity.subhead_subactivity_id)
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                </td>
                                                                                <td></td>
                                                                                <td>{activity.activity}</td>
                                                                                <td>{activity.subactivity}</td>
                                                                                <td>{activity.budget}</td>
                                                                            </tr>
                                                                        </>
                                                                    ))
                                                                }
                                                                </>
                                                            ))
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                            {/* </Form> */}
                        </div>
                    </div>
                </div>
                <Modal show={showConfirm} onHide={() => handleConfirm(false)} centered>
                    <Modal.Header closeButton={() => handleConfirm(false)}>
                        <Modal.Title>Confirm</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>If you want to change the scheme, you will lose any filled data. Are you sure you want to continue?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => confirmSubmit()}>
                            YES
                        </Button>
                        <Button variant="danger" onClick={() => handleConfirm(false)}>
                            No
                        </Button>
                    </Modal.Footer>
                </Modal></>
        )
}